export default __webpack_public_path__ + "static/media/pouring-chalice.fa948c93.png";